<template>
  <div class="service">
    <div class="content">
      <cpt-header></cpt-header>
      <cpt-credit></cpt-credit>
      <cpt-introduce></cpt-introduce>
      <cpt-process></cpt-process>
      <cpt-intelligent></cpt-intelligent>
      <cpt-advantages></cpt-advantages>
      <cpt-bottom></cpt-bottom>
    </div>
    <cpt-change-lang></cpt-change-lang>
  </div>
</template>

<script>
import cptHeader from '../../components/header/cpt-header.vue';
import cptBottom from '../../components/cpt-bottom.vue';
import cptCredit from '../../components/cpt-credit.vue';
import cptProcess from '../../components/cpt-process.vue';
import cptIntroduce from '../../components/cpt-introduce.vue';
import cptIntelligent from '../../components/cpt-intelligent.vue';
import cptAdvantages from '../../components/cpt-advantages.vue';
import cptChangeLang from '../../components/cpt-change-lang.vue';
export default {
  components: {
    cptHeader,
    cptBottom,
    cptCredit,
    cptProcess,
    cptIntroduce,
    cptIntelligent,
    cptAdvantages,
    cptChangeLang
  },
  data() {
    return {
    }
  },
  mounted(){
    window.scrollTo(0, 0)
  },
  methods: {

  },
}

</script>

<style lang='scss' scoped>
.service{
  width: auto;
  display: flex;
  justify-content: center;
  .content{
    width: 100%;
  }
}
</style>